import Home from "./Home.vue";
import { createApp } from "vue";

class EInvoiceProfile {
    constructor(wrapper, session_id) {
        this.$wrapper = $(wrapper);
        this.session_id = session_id;
        this.make_body();
    }
    make_body() {
        if (this.$wrapper.get(0).__vue_app__) {
            this.$wrapper.get(0).__vue_app__.unmount();
        }
        const app = createApp(Home, {
            frm: this.frm,
            session_id: this.session_id,
        });
        
        this.$component = app.mount(this.$wrapper.get(0));
    }
};

frappe.provide("myinvois.app");
myinvois.app.einvoice_profile = EInvoiceProfile;
export default EInvoiceProfile;